import { defineMessages } from 'react-intl';

type MessageKeys = 'jsmCreateRequestInstruction' | 'jsmRequestCreatedDescription';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		jsmCreateRequestInstruction: {
			id: 'conversation-assistant-message-actions.jsm-create-request.instruction',
			defaultMessage:
				'Review and edit the details below, then click {createButtonCopy} to create your request.',
			description:
				'Instruction text displayed in the Jira Service Management (JSM) request creation action card within the AI conversation interface, providing guidance on the next steps. Shown as instructional text in the action card body. The createButtonCopy placeholder will be substituted with the text of the create button (e.g., "Create request", "Raise request"). The purpose is to guide users to review the AI-suggested request details and then proceed with creation using the button.',
		},
		jsmRequestCreatedDescription: {
			id: 'conversation-assistant-message-actions.jsm-create-embedded-request.created-description',
			defaultMessage: 'Your service request has been created successfully.',
			description:
				'Success message text displayed in the body of a success notification or dialog after a Jira Service Management (JSM) service request has been successfully created within the AI conversation interface. Shown as the description text below the success title. The purpose is to confirm the successful creation of the service request and inform the user that their request is now active.',
		},
	});

export default message;
